import React from 'react';
import { Form, Input } from 'antd';
import RadioTags from '../../../components/RadioTags';

class UserDefinedTemplateFields extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {

  }

  getFieldsValue = () => {
    return this.formRef.getFieldsValue();
  }

  validateFields = () => {
    return this.formRef.validateFields();
  }

  resetFields = () => {
    this.formRef && this.formRef.resetFields();
  }

  render() {
    let {template} = this.props;

    return <Form ref={form => this.formRef = form} layout='vertical'
                 className='form-compact' requiredMark={false}>
      {
        template.map((item, index) => {
          if (item.type === 'charge_account' || item.type === 'text') {
            return <Form.Item
              key={index}
              label={item.name}
              name={item.type === 'charge_account' ? 'charge_account' : ((!item.key || item.key === '') ? item.name : item.key)}
              extra={item.comment}
              rules={[{required: true}]}
            >
              <Input style={{width: 200}}/>
            </Form.Item>
          } else if (item.type === 'password') {
            return <Form.Item
              key={index}
              label={item.name}
              name={item.type === 'charge_account' ? 'charge_account' : ((!item.key || item.key === '') ? item.name : item.key)}
              extra={item.comment}
              rules={[{required: true}]}
            >
              <Input.Password style={{width: 200}}/>
            </Form.Item>
          } else if (item.type === 'select') {
            return <Form.Item
              key={index}
              label={item.name}
              name={item.type === 'charge_account' ? 'charge_account' : ((!item.key || item.key === '') ? item.name : item.key)}
              extra={item.comment}
              rules={[{required: true}]}
            >
              <RadioTags options={this.parseOptions(item.options)}/>
            </Form.Item>
          } else {
            return <div key={index}/>
          }
        })
      }
    </Form>
  }

  rechargeAccountField = (label = null) => {
    label = label ? label : '充值账号';
    const message = `请输入${label}`;
    return <Form.Item
      label={label}
      name='charge_account'
      rules={[{required: true, message: {message}}]}
    >
      <Input style={{width: 200}}/>
    </Form.Item>
  }

  parseOptions = (options) => {
    let optionsParsed = [];
    options.forEach(item => {
      optionsParsed.push({
        label: item,
        value: item
      })
    })
    return optionsParsed;
  }
}

export default UserDefinedTemplateFields;